import PopupFetchController from "../../../../javascript/stimulusControllers/shared/popup-fetch-controller";

export default class extends PopupFetchController {}



// WEBPACK FOOTER //
// ./app/components/calendars/assets/javascript/calendars-time-summary-display-link-controller.js